import React, { useEffect, useState } from "react";
import {
  Button,
  InfoText,
  LogoLoader,
  Modal,
  NewTab,
  TableAdv,
} from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { keyToTitle, mapTableRows } from "../../../../utils";
import OldInformation from "./LeadView/OldInformation";
import Jobs from "./LeadView/Jobs";
import OtherContacts from "./LeadView/OtherContacts";
import {
  getLeadCompanyByUiid,
  getLeadContacts,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { formatWords2 } from "../../../../utils/stringUtils";
import { usePagination } from "../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import AddContactModal from "../Modals/AddContactModal";
import { useLoginUser } from "../../../../hooks/useLoginUser";

const LeadView = () => {
  const navigate = useNavigate();
  const leadCompanyUiid = sessionStorage.getItem("leadCompanyUiid");
  const [companyName, setCompanyName] = useState("-");
  const [loading, setLoading] = useState(false);
  const [clientContacts, setClientContacts] = useState([]);
  const [oldInfo, setOldInfo] = useState(null);
  const [addContactModal, setAddContactModal] = useState(false);
  const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const { value } = useSelector((state) => state?.totalCount);
  const totalCount = value?.clientContactCnt?.data || 0;
  const [leadInfo, setLeadInfo] = useState([]);
  const [addContactType, setAddContactType] = useState(null);
  const {userData:loginUserData} = useLoginUser();
  
  // const leadInfo = [
  //   {
  //     Name: "Astha Vaish",
  //     Email: "asthavaish@tektree.in",
  //     Mobile: "+91 8472834616",
  //   },
  // ];
  // const leadInfo = [
  //   {
  //     Name: "-",
  //     Email: "-",
  //     Mobile: "-",
  //   },
  // ];

  const columns = [
    {
      key: "name",
      label: "Name",
      columnMenu: false,
    },
    {
      key: "email",
      label: "Email",
      columnMenu: false,
    },
    // {
    //   key: "",
    //   label: "",
    //   align: "right",
    //   render: (row) =>
    //     row?.url != "" ? (
    //       <Button
    //         type="icon"
    //         color="info"
    //         icon="open_in_new"
    //         variant="text"
    //         size="sm"
    //         onClick={() => window.open(row.url, "_blank")}
    //       />
    //     ) : (
    //       "-"
    //     ),
    // },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Mate ryson",
  //     email: "mate35@csat.com",
  //   },
  //   {
  //     id: 2,
  //     name: "Mate ryson",
  //     email: "mate35@csat.com",
  //   },
  //   {
  //     id: 3,
  //     name: "Mate ryson",
  //     email: "mate35@csat.com",
  //   },
  // ];
  const rows = clientContacts.map((item) => ({
    id: item?.uiid || "-",
    name: formatWords2(
      `${item?.firstName || ""} ${item?.lastName || ""}`.trim() || "-",
    ),
    email: item?.email || "-",
    url: item?.url || "",
  }));
  const fetchLeadCompany = async () => {
    try {
      setLoading(true);
      const res = await getLeadCompanyByUiid({
        coll: "LeadCompany",
        ret: "uiid name oldInfo isTektree",
        fil: {
          uiid: { type: "NONE", value: leadCompanyUiid },
        },
      });
      const company = res?.data?.data;
      setCompanyName(formatWords2(company?.name || "-"));
      setOldInfo(company?.oldInfo || null);
    } catch (error) {
      console.error("Failed to fetch lead company", error);
    } finally {
      setLoading(false);
    }
  };

 const fetchPrimaryContacts = async () => {
  const params = {
    coll: "LeadContact",
    ret: "uiid firstName lastName email mobile",
    fil: JSON.stringify({
      companyId: { type: "NONE", value: leadCompanyUiid }, 
      isPrimary: { type: "NONE", value: true },
      isClient:{ type:"NONE",value:false}
    }),
  };
  try{
  const res = await getLeadContacts(params);
      const data = res?.data?.data || [];

      const contacts =
        data.length > 0
          ? data.map((c) => ({
              Name: formatWords2(
                `${c?.firstName || ""} ${c?.lastName || ""}`.trim() || "-",
              ),
              Email: c?.email || "-",
              Mobile: c?.mobile?.number
                ? `${c?.mobile?.code || ""} ${c?.mobile?.number}`.trim()
                : "-",
            }))
          : [{ Name: "-", Email: "-", Mobile: "-" }];

      setLeadInfo(contacts);
    } catch (error) {
      console.error("Failed to fetch primary contacts", error);
    }
};
  const LeadViewMenus = [
    {
      title: "Old Information",
      page: (
        <OldInformation
          oldInfo={oldInfo}
          companyUiid={leadCompanyUiid}
          onUpdated={fetchLeadCompany}
        />
      ),
      type: "main",
      id: "priorityleadsview_oldinformation",
    },
    {
      title: "Jobs",
      page: <Jobs companyUiid={leadCompanyUiid} />,
      type: "main",
      id: "priorityleadsview_jobs",
    },
    {
      title: "Other Contacts",
      page: <OtherContacts companyUiid={leadCompanyUiid} />,
      type: "main",
      disabled: true,
      id: "priorityleadsview_othercontacts",
    },
  ];

  const mappedRows = mapTableRows(rows, columns);
  const fetchClientContacts = async () => {
    try {
      const params = {
        coll: "LeadContact",
        ret: "uiid firstName lastName email url",
        fil: JSON.stringify({
          isClient: { type: "NONE", value: true },
          companyId: { type: "NONE", value: leadCompanyUiid },
        }),
        lim: limit,
        pg: page,
      };
      const res = await getLeadContacts(params);

      setClientContacts(res?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch client contacts", err);
    }
  };
  useEffect(() => {
    if (!leadCompanyUiid) return;

    fetchLeadCompany();
    fetchPrimaryContacts();
  }, [leadCompanyUiid]);

  useEffect(() => {
    if (!leadCompanyUiid) return;
    dispatch(
      totalCountStart({
        collection: "leadcontacts",
        coll: "LeadContact",
        tname: "clientContactCnt",
        app: "ats",
        filters: {
          isClient: { type: "NONE", value: true },
          companyId: { type: "NONE", value: leadCompanyUiid },
        },
      }),
    );

    fetchClientContacts();
  }, [leadCompanyUiid, limit, page]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("leadCompanyUiid");
    };
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LogoLoader />
      </div>
    );
  }
  if (!leadCompanyUiid) {
    return <div className="p-4 text-red-500">No job found for this ID.</div>;
  }
console.log(leadInfo)
  return (
    <div className="bg-white rounded-lg p-2 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <Button
          title="Lead Details"
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="text-md font-semibold"
          onClick={() => navigate("/ats/bdm/priority-leads")}
        />
      </div>

      <div className="flex flex-col rounded-md bg-[#f9f9f9] p-3 sm:p-5 shadow-md">
        <div className="flex justify-between items-center mb-2">
          <p className="text-sm font-semibold text-gray-700 mb-2">
            {loginUserData?.organizationId?.name} Contact
          </p>
          <Button
            title={"Add Contact"}
            icon={"add"}
            size="sm"
            onClick={() => {
              setAddContactType("org");
              setAddContactModal(true);
            }}
            disabled={ leadInfo.length !== 0 }
          />
        </div>
        <div className="mx-0 flex flex-col gap-3 sm:gap-5 inner-section p-3 sm:p-4 rounded">
          {/* {Object.entries(leadInfo[0]).map(([key, value]) => (
            <InfoText
              key={key}
              size="sm"
              title={keyToTitle(key)}
              value={value}
            />
          ))} */}
          {leadInfo.map((contact, index) => (
            <div
              key={index}
              className="col-span-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5"
            >
              {Object.entries(contact).map(([key, value]) => (
                <InfoText
                  key={`${index}-${key}`}
                  size="sm"
                  title={keyToTitle(key)}
                  value={
                    key === "Mobile" &&
                    typeof value === "object" &&
                    value !== null
                      ? `${value.code || ""} ${value.number || ""}`.trim() ||
                        "-"
                      : value
                  }
                />
              ))}
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 mt-3">
          <p className="text-sm font-semibold text-gray-700">
            {companyName} Contact Information
          </p>

          <div className="rounded-md bg-white overflow-y-hidden overflow-x-auto">
            <div className="max-h-64 overflow-y-auto overflow-x-auto">
              <TableAdv
                columns={columns}
                rows={mappedRows}
                showSlNo
                serverPagination={true}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                tdClassName="!py-3"
                toolbarRight={{
                  search: false,
                  fullScreen: false,
                  filter: false,
                  add: [
                    {
                      component: (
                        <Button
                          title={"Add Contact"}
                          icon={"add"}
                          size="sm"
                          onClick={() => {
                            setAddContactType("client");
                            setAddContactModal(true);
                          }}
                        />
                      ),
                    },
                  ],
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="flex-1 mx-0 sm:mx-3 rounded-xl">
          <NewTab
            tabs={LeadViewMenus}
            color="gray"
            variant="text"
            activeVariant="text"
            mode="url"
            tabId="account-details"
          />
        </div>
      </div>
      <Modal
        isOpen={addContactModal}
        onClose={() => setAddContactModal(false)}
        title={"Add Contact"}
        titleColor={"primary"}
        width="max-w-5xl"
      >
        <AddContactModal
          onCancel={() => setAddContactModal(false)}
          companyUiid={
            addContactType === "org"
              ? loginUserData?.organizationId?.uiid
              : leadCompanyUiid
          }
          isClient={addContactType === "client"}
          onSuccess={() => {
            setAddContactModal(false);
            if (addContactType === "org") {
              fetchPrimaryContacts();
            } else {
              fetchClientContacts();
            }
          }}
        />
      </Modal>
    </div>
  );
};

export default LeadView;
